/* eslint-disable */
import { FC, ReactNode } from 'react';
import styles from '../../styles/components/controlVariations/ModularConfirmDelete.module.css';
import DefaultIcon from '../../assets/icons/PopupErrorIcon.png';

interface ConfirmContentProps {
	title?: string;
	message?: string;
	icon?: string;

	confirmText?: string;
	cancelText?: string;

	onConfirm: () => void;
	onCancel: () => void;

	children?: ReactNode;
	className?: string;
}

const ConfirmContent: FC<ConfirmContentProps> = ({
	title = 'Are you sure?',
	message,
	icon = DefaultIcon,

	confirmText = 'Confirm',
	cancelText = 'Cancel',

	onConfirm,
	onCancel,

	children,
	className = '',
}) => {
	return (
		<div className={`${styles.modal} ${className}`}>
			<div className={styles.iconWrapper}>
				<img src={icon} alt="confirm-icon" />
			</div>

			<h2 className={styles.title}>{title}</h2>

			{message && <p className={styles.message}>{message}</p>}

			{children}

			<div className={styles.actions}>
				<button className={styles.logoutButton} onClick={onConfirm}>
					{confirmText}
				</button>
				<button className={styles.cancelButton} onClick={onCancel}>
					{cancelText}
				</button>
			</div>
		</div>
	);
};

export default ConfirmContent;
